(() => {
  'use strict';

  if (window.initAwSliderCarousels) {
    window.initAwSliderCarousels();
    return;
  }

const initProductCarousels = (scope = document) => {
  const $scrollbars = scope.querySelectorAll('.product-carousel-scrollbar');
  if (!$scrollbars.length) return;

  $scrollbars.forEach($scrollbar => {
    if ($scrollbar.dataset.scrollbarInitialized === 'true') return;

    const carouselId = $scrollbar.getAttribute('aria-controls');
    const $list = carouselId ? document.getElementById(carouselId) : null;
    const $thumb = $scrollbar.querySelector('.product-carousel-scrollbar-thumb');
    if (!$list?.matches('.product-carousel-list') || !$thumb) return;

    $scrollbar.dataset.scrollbarInitialized = 'true';

    const update = () => {
      const maximumScroll = $list.scrollWidth - $list.clientWidth;
      const hasOverflow = maximumScroll > 1;
      $scrollbar.hidden = !hasOverflow;

      if (!hasOverflow) return;

      const thumbWidth = Math.max(($list.clientWidth / $list.scrollWidth) * 100, 8);
      const progress = $list.scrollLeft / maximumScroll;
      $thumb.style.width = `${thumbWidth}%`;
      $thumb.style.left = `${progress * (100 - thumbWidth)}%`;
      $scrollbar.setAttribute('aria-valuenow', Math.round(progress * 100));
    };

    let activePointerId = null;
    let pointerOffset = 0;

    const scrollFromPointer = clientX => {
      const maximumScroll = $list.scrollWidth - $list.clientWidth;
      const scrollbarRect = $scrollbar.getBoundingClientRect();
      const thumbRect = $thumb.getBoundingClientRect();
      const availableTrackWidth = scrollbarRect.width - thumbRect.width;
      if (maximumScroll <= 0 || availableTrackWidth <= 0) return;

      const progress = Math.min(Math.max((clientX - scrollbarRect.left - pointerOffset) / availableTrackWidth, 0), 1);
      $list.scrollLeft = progress * maximumScroll;
    };

    $scrollbar.addEventListener('pointerdown', event => {
      const maximumScroll = $list.scrollWidth - $list.clientWidth;
      if (maximumScroll <= 0) return;

      const thumbRect = $thumb.getBoundingClientRect();
      activePointerId = event.pointerId;
      pointerOffset = event.target === $thumb ? event.clientX - thumbRect.left : thumbRect.width / 2;
      $scrollbar.setPointerCapture(activePointerId);
      $scrollbar.classList.add('is-dragging');
      scrollFromPointer(event.clientX);
    });

    $scrollbar.addEventListener('pointermove', event => {
      if (event.pointerId !== activePointerId) return;
      scrollFromPointer(event.clientX);
    });

    const finishDragging = event => {
      if (event.pointerId !== activePointerId) return;
      if ($scrollbar.hasPointerCapture(activePointerId)) $scrollbar.releasePointerCapture(activePointerId);
      activePointerId = null;
      $scrollbar.classList.remove('is-dragging');
    };

    $scrollbar.addEventListener('pointerup', finishDragging);
    $scrollbar.addEventListener('pointercancel', finishDragging);

    $scrollbar.addEventListener('keydown', event => {
      const maximumScroll = $list.scrollWidth - $list.clientWidth;
      const step = $list.clientWidth * 0.25;
      let destination = null;

      if (event.key === 'ArrowLeft') destination = $list.scrollLeft - step;
      if (event.key === 'ArrowRight') destination = $list.scrollLeft + step;
      if (event.key === 'Home') destination = 0;
      if (event.key === 'End') destination = maximumScroll;
      if (destination === null) return;

      event.preventDefault();
      $list.scrollLeft = Math.min(Math.max(destination, 0), maximumScroll);
    });

    $list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe($list);
    update();
  });
};

window.initAwSliderCarousels = initProductCarousels;
initProductCarousels();

document.addEventListener('shopify:section:load', event => {
  initProductCarousels(event.target);
});

const $carouselProductRecommendations = document.querySelectorAll('product-recommendations');
if ($carouselProductRecommendations.length) {
  $carouselProductRecommendations.forEach($wrapper => {
    const observer = new MutationObserver(mutations => {
      const hasAddedNodes = mutations.some(mutation => mutation.addedNodes && mutation.addedNodes.length > 0);
      if (hasAddedNodes) initProductCarousels($wrapper);
    });

    observer.observe($wrapper, {
      childList: true,
      subtree: true
    });
  });
}
})();
